<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  <nsp-number-input
    [id]="'gmReserve'"
    [name]="'gmReserve'"
    label="GM Reserve"
    [unit]="'cm'"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('gmReserve')"
    [readonly]="isFieldReadOnly('gmReserve')"
    [value]="operationalStore.stabilityConditions?.()?.gmReserve?.value"
    [ngModel]="operationalStore.stabilityConditions?.()?.gmReserve?.value"
  />
  <nsp-number-input
    [id]="'deadWeightReserve'"
    [name]="'deadWeightReserve'"
    label="Dead Weight Reserve"
    [unit]="'MT'"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('deadWeightReserve')"
    [readonly]="isFieldReadOnly('deadWeightReserve')"
    [value]="operationalStore.stabilityConditions?.()?.deadWeightReserve?.value"
    [ngModel]="
      operationalStore.stabilityConditions?.()?.deadWeightReserve?.value
    "
  />
</form>
